import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import { Button } from '@material-ui/core';

export const AddSetContainer = styled(Grid)``;
export const ButtonBox = styled(Box)`
    margin-left: 20px;

    & .ButtonGroup {
    }

    & .ButtonStyle {
        min-width: fit-content;
        min-height: 30px;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
        text-transform: capitalize;
        font-weight: 500;
        color: #202124;
        opacity: 1;
        letter-spacing: 0;
    }
`;
export const ButtonStyle = styled(Button)`
    background-color: '${(props) =>
        props.clickedButton === props.key && '#ebeded'}';

    & :hover {
        background-color: '${(props) =>
            props.clickedButton === props.key && '#ebeded'}';
    }
`;

export const AddSetScan = styled(Grid)`
    & .AddSetTabs Button {
        min-width: fit-content;
        min-height: 30px;
        font-size: 14px;
        font-family: 'AvenirNextWorld Regular';
        text-transform: capitalize;
        font-weight: 500;
        padding: 0;
        color: #202124;
        opacity: 1;
        letter-spacing: 0;
    }

    & .AddSetTabs {
        min-height: 30px;
    }

    & .AddSetTabs Button span {
        flex-direction: row;
        justify-content: left;
    }

    & .AddSetTabs .MuiTabs-indicator {
        background-color: #1021eb;
    }

    & .AddSetTabs Button.ExternalScannerTab {
        margin-left: 15px;
    }

    & .AddSetTabs Button.Mui-selected {
        font-family: 'AvenirNextWorld Demi';
    }
`;

export const TabContainer = styled.div`
    padding: 10px 0 0 0;
`;

export const AddSetBatch = styled.div`
    margin: 10px 0 2px 0;
`;

export const ButtonContainer = styled.div`
    width: 100%;
    flex-direction: row;
    display: flex;
    align-items: center;
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Demi;
    font-size: 14px;
    letter-spacing: -0.12px;
    align-self: center;
    padding: ${(props) => props.isScan && '0 0 0 10px'};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }
`;

export const SuccessMsg = styled.div`
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #14853d;
    float: ${(props) => props.float};
    ${media.mobileDevice` 
       margin: ${({ mbMargin }) => mbMargin && mbMargin};
    `};
`;
